export default {
  namespaced: true,

  state: {
    downloading: false,
    query: {
      searchDateFrom: '',
      searchDateTo: '',
      genreId: [],
      excludedNoCompanyTel: 'false',
      cityCd: [],
      keyword: '',
      order: 'created_at',
    },
  },
  getters: {
    apiQuery: state =>
      ({
        searchDateFrom: state.query.searchDateFrom,
        searchDateTo: state.query.searchDateTo,
        genreId: state.query.genreId.map(m => (m.value || m)).join(','),
        excludedNoCompanyTel: state.query.excludedNoCompanyTel,
        cityCd: state.query.cityCd.map(p => (p.value || p)).join(','),
        keyword: state.query.keyword,
        order: state.query.order,
      })
    ,
  },
  mutations: {
    searchDateFrom: (state, value) => state.query.searchDateFrom = value,
    searchDateTo: (state, value) => state.query.searchDateTo = value,
    genreId: (state, value) => state.query.genreId = value,
    excludedNoCompanyTel: (state, value) => state.query.excludedNoCompanyTel = value,
    cityCd: (state, value) => state.query.cityCd = value,
    keyword: (state, value) => state.query.keyword = value,
    order: (state, value) => state.query.order = value,
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/searchStartingBusiness.js